import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import AppGlobalContext from "../../../AppGlobalContext";
import fire from "../../../services/fire";
import Header from "../../common/header";
import EventCardFull from "../component/v2/EventCardFull";
import PageNotFound from "../../common/pageNotFound";
import { setEventInterest } from "../utils/eventGeneralHelpers";
import { useHistory } from "react-router-dom";
import LoadingSpinner from "../../common/loadingSpinner";
import LinkButton from "../../blocks/linkButtonBlock";
import { checkOrgRestriction } from "../utils/eventHelpers";
import LoginMiniForm from "../../account/page/loginMini";
import { Modal } from "react-bootstrap";
import ReloadModal from "../../common/reloadModal";
const INITIAL_STATE = {
  isLoading: true,
  isNotFound: true,
  eventDetails: {},
  isLoginModalOpen: false,
  isLoginSuccess: false,
  buttonClicked: "",
  selectedSchedule: "",
};

const EventPage = () => {
  const [eventPageState, setEventPageState] = useState({ ...INITIAL_STATE });
  const {
    isLoading,
    isNotFound,
    eventDetails,
    isLoginModalOpen,
    isLoginSuccess,
    buttonClicked,
  } = eventPageState;
  const { id } = useParams();
  const { user } = useContext(AppGlobalContext);
  const history = useHistory();

  const bookEvent = (eventId) => {
    // Go to booking review page here
    history.push(`/events/${eventId}/review`);
  };

  const setInterest = (eventId, cb) => {
    // Call set user interest function here
    setEventInterest(eventId, id, user, cb);
  };

  useEffect(() => {
    if (id) {
      fire
        .firestore()
        .collection("evententries")
        .where("parentEventId", "==", id)
        .get()
        .then((snapshot) => {
          //if event doesn't exist
          if (snapshot.empty) {
            setEventPageState({
              ...eventPageState,
              isLoading: false,
              isNotFound: true,
            });
          } else {
            const eventResults = [];
            snapshot.docs.forEach((doc) => {
              const eventObj = doc.data();
              if (
                !eventObj.isPrivate &&
                ((user && checkOrgRestriction(eventObj, user.parish)) ||
                  (!user && !eventObj?.orgRestrictions) ||
                  eventObj?.orgRestrictions?.length === 0)
              ) {
                eventResults.push(eventObj);
                const eventSchedules = [];
                eventResults.forEach((event) => {
                  const startDateObj = new Date(event.startDate.seconds * 1000);
                  const endDateObj = new Date(event.endDate.seconds * 1000);
                  const bookingDateObj = new Date(
                    event.bookingStartDate.seconds * 1000
                  );
                  const bookingEndDateObj = new Date(
                    event.bookingEndDate.seconds * 1000
                  );
                  eventSchedules.push({
                    eventId: event.eventId,
                    startDate: startDateObj,
                    endDate: endDateObj,
                    eventLocation: event.eventLocation,
                    eventVenue: event.eventVenue,
                    capacity: event.capacity,
                    available: event.available,
                    hasReserve: event.hasReserve,
                    reserveCapacity: event.reserveCapacity,
                    bookingStartDate: bookingDateObj,
                    bookingEndDate: bookingEndDateObj,
                    availableSlots: event.availableSlots,
                    isWalkIn: event.isWalkIn,
                  });
                });
                setEventPageState({
                  ...eventPageState,
                  isLoading: false,
                  isNotFound: false,
                  eventDetails: {
                    eventName: eventResults[0].eventName,
                    eventOrgName: eventResults[0].eventOrgName,
                    eventDescription: eventResults[0].eventDescription,
                    eventTags: eventResults[0].eventTags,
                    eventCost: eventResults[0].eventCost,
                    eventImage: eventResults[0].eventImage,
                    eventSchedules,
                  },
                });
              } else {
                setEventPageState({
                  ...eventPageState,
                  isLoading: false,
                  isNotFound: true,
                });
              }
            });
          }
        });
    } else {
    }
    // Run effect once on component mount, recheck if deps updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, user]);

  useEffect(() => {
    if (user && isLoginSuccess && buttonClicked === "booking") {
      window.location.reload();
    }
  }, [user, isLoginSuccess]);

  return (
    <>
      <Header hide={user ? "" : "profile"} />
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {isNotFound ? (
            <>
              {user ? (
                <PageNotFound
                  isEventOrForm
                  content="Seems like the event does not exist or is not open to your parish."
                  link="/events"
                  label="Return to Events Page"
                />
              ) : (
                <Modal keyboard={false} show={true} size="sm">
                  <Modal.Header className="border-0 pb-0" />
                  <Modal.Body className="px-4">
                    <LoginMiniForm
                      source="eventpage"
                      successCallback={() => {
                        setEventPageState({
                          ...eventPageState,
                          isLoginSuccess: true,
                          isLoading: true,
                        });
                      }}
                    />
                  </Modal.Body>
                </Modal>
              )}
            </>
          ) : (
            <div className="container">
              <Modal
                keyboard={false}
                onHide={() =>
                  setEventPageState({
                    ...eventPageState,
                    isLoginModalOpen: false,
                  })
                }
                show={isLoginModalOpen}
                size="lg"
              >
                <Modal.Header className="border-0 pb-0" closeButton />
                <LoginMiniForm
                  source="eventpage"
                  successCallback={() => {
                    setEventPageState({
                      ...eventPageState,
                      isLoginModalOpen: false,
                      isLoginSuccess: true,
                    });
                  }}
                />
              </Modal>
              <ReloadModal />
              <EventCardFull
                eventDetails={eventDetails}
                bookEvent={bookEvent}
                setInterest={setInterest}
                eventPageState={eventPageState}
                setEventPageState={setEventPageState}
              />
              <LinkButton
                type="link"
                label="Back to Event Hub"
                link="/events"
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default EventPage;
